<template>
  <div class="home">
    <header-com></header-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">账号使用查询</h3>
        <div class="wrap">
          <el-form :inline="true" :model="formInline" size="small">
            <!-- <el-form-item style="width:200px">
              <el-input v-model="formInline.orderNo" placeholder="订单编号" clearable></el-input>
            </el-form-item>-->
            <el-form-item style="width:200px">
              <el-input v-model="formInline.orderPackagebagName" placeholder="课程名称" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-input v-model="formInline.content" placeholder="课程内容" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formInline.pay" placeholder="是否支付" clearable>
                <el-option label="是" value="shanghai"></el-option>
                <el-option label="否" value="beijing"></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item style="width: 400px">
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
              <!-- <el-button type="success" size="small">导出结果</el-button> -->
              <!-- <el-button type="success" size="small">支付</el-button>-->
            </el-form-item>
          </el-form>
          <el-table
            :data="tableList"
            border
            max-height="640"
            style="width: 100%"
            highlight-current-row
            :header-cell-style="{background:'#dde9fc',color:'#606266'}"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <!-- <el-table-column type="selection" width="50"></el-table-column> -->
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <!-- <el-table-column prop="orderNo" label="订单编号" min-width="100"></el-table-column> -->
            <el-table-column prop="courseName" label="课程名称" min-width="100"></el-table-column>
            <!-- <el-table-column prop="city" label="课程内容" min-width="100"></el-table-column> -->
            <el-table-column prop="orderPersoncount" label="新开账号数量" min-width="100"></el-table-column>
            <!-- <el-table-column prop="2" label="单价(元)" min-width="100"></el-table-column>
            <el-table-column prop="3" label="总价(元)" min-width="100"></el-table-column>-->
            <el-table-column prop="termOfValidity" label="课程有效期(天)" min-width="100"></el-table-column>
            <!-- <el-table-column prop="orderCount" label="已使用账号" min-width="100"></el-table-column> -->
            <el-table-column label="已使用账号" width="120" tree-props="{children: 'children'}">
              <template slot-scope="scope">
                <el-button
                  style="text-decoration: underline;color:#00f"
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                >{{scope.row.orderCount}}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="sysCreatetime" label="下单时间" min-width="100"></el-table-column>
            <!-- <el-table-column prop="6" label="是否支付" width="120"></el-table-column> -->
          </el-table>
          <pagination
            :currentPage="currentPage"
            :total="total"
            :limit="limit"
            ref="page"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <!-- 查看已使用账号 -->
    <el-dialog title="查看已使用账号" :visible.sync="usedDialog" width="90%" center>
      <el-form :inline="true" :model="usedForm" size="small">
        <el-form-item style="width:120px" prop="empName">
          <el-input v-model="usedForm.empName" placeholder="姓名" clearable></el-input>
        </el-form-item>
        <el-form-item prop="empIdcard" style="width:180px">
          <el-input v-model="usedForm.empIdcard" placeholder="证件号码" clearable></el-input>
        </el-form-item>
        <el-form-item prop="affiliatedEnterprise">
          <el-input v-model="usedForm.affiliatedEnterprise" placeholder="所属企业" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item prop="postId">
          <el-select v-model="usedForm.postId" placeholder="专业" clearable @change="specialChange">
            <el-option
              v-for="(item,i) in specialList"
              :key="i"
              :label="item.postName"
              :value="item.postId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="batchId">
          <el-select v-model="usedForm.batchId" placeholder="报名批次" clearable>
            <el-option
              v-for="(item,i) in batchList"
              :key="i"
              :label="item.batchName"
              :value="item.batchId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="regHasCourse">
          <el-select
            v-model="usedForm.regHasCourse"
            placeholder="课程激活状态"
            clearable
            @change="activeState"
          >
            <el-option label="未激活" value="0"></el-option>
            <el-option label="已激活" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sysDeleted">
          <el-select
            v-model="usedForm.sysDeleted"
            placeholder="选择状态"
            clearable
            @change="stateChange"
          >
            <el-option label="正常" value="0"></el-option>
            <el-option label="已作废" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-date-picker
          class="picker"
          style="margin-right:10px"
          v-model="applyValue"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="报名时间起"
          end-placeholder="报名时间止"
          size="small"
          align="right"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker> -->
        <el-button type="primary" size="small" @click="usedSearch">搜索</el-button>
      </el-form>
      <el-table
        :data="usedList"
        border
        max-height="600"
        ref="fileTable"
        :cell-style="cellStyle"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        highlight-current-row
        :header-cell-style="{background:'#dde9fc',color:'#606266'}"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="regName" label="姓名" min-width="80"></el-table-column>
        <el-table-column prop="regSex" label="性别" :formatter="sexFormat" width="80"></el-table-column>
        <el-table-column prop="regIdcard" label="身份证号" min-width="120"></el-table-column>
        <el-table-column prop="regTel" label="手机号" min-width="80"></el-table-column>
        <el-table-column prop="postName" label="专业" min-width="120"></el-table-column>
        <el-table-column
          prop="affiliatedEnterprise"
          label="所属企业"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="batchName" label="报名批次" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column prop="sysCreatetimeStr" label="报名时间" min-width="120"></el-table-column>
        <!-- <el-table-column prop="regCategory" label="是否有后台权限" :formatter="hasFormat" width="120"></el-table-column> -->
        <el-table-column prop="regHasCourse" label="课程激活状态" :formatter="stateFormat" width="120"></el-table-column>
        <el-table-column prop="sysDeleted" label="状态" :formatter="sysFormat" width="100"></el-table-column>
      </el-table>
      <pagination
        :currentPage="usedCurrentPage"
        :total="usedTotal"
        :limit="usedLimit"
        ref="page"
        @handleCurrentChange="usedCurrentChange"
        @handleSizeChange="usedSizeChange"
      />
    </el-dialog>
  </div>
</template>

<script>
import HeaderCom from "../components/Header.vue";
import http from "../api/module";
import pagination from "../components/pagination";

export default {
  name: "queryCourse",
  components: {
    HeaderCom,
    pagination
  },
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页
      limit: 20, // 每页显示数量
      total: 0, // 总条目数
      usedCurrentPage: 1, // 当前页
      usedLimit: 20, // 每页显示数量
      usedTotal: 0, // 已使用账号总条目数
      formInline: {},
      tableList: [],
      usedDialog: false,
      usedForm: {},
      applyValue: [],
      specialList: JSON.parse(sessionStorage.getItem("specialList")),
      batchList: JSON.parse(sessionStorage.getItem("batchList")),
      usedList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 当前页
    handleCurrentChange(val) {
      console.log(val, "当前页");
      this.currentPage = val;
      this.getData();
    },
    // 每页数
    handleSizeChange(val) {
      this.currentPage = 1;
      this.limit = val;
      this.getData();
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getData();
    },
    getData() {
      this.loading = true;
      http
        .getOrder({
          pageNum: this.currentPage,
          pageSize: this.limit,
          orderNo: this.formInline.orderNo,
          courseName: this.formInline.orderPackagebagName
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.tableList = data.data.data.map(item => {
              var orderCount = item.orderCount;
              return item;
            });
            this.total = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    specialChange(val) {
      this.postId = val;
    },
    activeState(val) {
      this.usedForm.activeState = val;
    },
    stateChange(val) {
      this.usedForm.sysDeleted = val;
    },
    // 已使用账号
    handleClick(row) {
      console.log(row);
      this.cateCode = row.orderNo;
      this.usedDialog = true;
      this.getInfo();
    },
    usedCurrentChange(val) {
      this.usedCurrentPage = val;
      this.getInfo();
    },
    usedSizeChange(val) {
      this.usedLimit = val;
      this.getInfo();
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 9) {
        return row.regHasCourse == 0 ? "color:#F56C6C" : "color:#67C23A";
      } else if (columnIndex === 10) {
        return row.sysDeleted == 2 ? "color:#F56C6C" : "color:#67C23A";
      } else {
        return "";
      }
    },
    sexFormat(row) {
      var regSex = row.regSex;
      return regSex == "0" ? "男" : "女";
    },
    hasFormat(row) {
      var regCategory = row.regCategory;
      return regCategory == "2" ? "是" : "否";
    },
    sysFormat(row) {
      var sysDeleted = row.sysDeleted;
      return sysDeleted == "0" ? "正常" : "作废";
    },
    stateFormat(row, column) {
      var state = row.regHasCourse;
      return state == "0" ? "未激活" : "已激活";
    },
    usedSearch() {
      this.usedCurrentPage = 1;
      this.$refs.page.init();
      this.getInfo();
    },
    // 已使用账号table
    getInfo() {
      this.loading = true;
      http
        .getUserInfo({
          pageNum: this.usedCurrentPage,
          pageSize: this.usedLimit,
          cateCode: this.cateCode,
          sysDeleted: 0,
          empName: this.usedForm.empName,
          empIdcard: this.usedForm.empIdcard,
          affiliatedEnterprise: this.usedForm.affiliatedEnterprise
          // postId: this.postId,
          // batchId: this.usedForm.batchId,
          // regHasCourse: this.usedForm.regHasCourse,
          // sysDeleted: this.usedForm.sysDeleted,
          // startTime: this.applyValue ? this.applyValue[0] : null,
          // endTime: this.applyValue ? this.applyValue[1] : null
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.usedList = data.data.data.map((item, i) => {
              item.index = i;
              return item;
            });
            this.usedTotal = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    // 批量打印培训证明
    batchPrint() {
      this.$confirm("确认打印培训证明吗?", "批量打印培训证明", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "打印成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打印"
          });
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-button--mini,
.el-button--small {
  font-size: 14px;
}
.cont {
  margin-top: 20px;
  .wrap {
    padding: 20px;
  }
  .title {
    font-size: 18px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
</style>
